import type { SupabaseClient } from '@supabase/supabase-js';
import { renderOrdersTab } from './tabs/orders.js';
import { infoBadge } from '../lib/info-badge.js';
import { helpButtonHtml, wireHelpButtons } from '../lib/help-panel.js';
import { connectionPillHtml } from '../lib/connection-pill.js';

// Standalone-Bestellfenster für den Vario-Verkaufskanal-Tab (Slot
// settings.sales-channels.{appId}.tabs → /#/orders). Rendert NUR die Bestellansicht
// im neuen Design: Mock-Header (go-eCommerce- + Gambio-Logo, Titel)
// und darunter die Bestell-Oberfläche - bewusst OHNE die App-Menü-/Tab-Leiste
// (Produkte/Varianten/Angebote/„Auf Gambio anlegen"/Log/Einstellungen). Die Navigation
// drumherum stellt der Vario-Verkaufskanal selbst.

interface OrdersPageContext {
  contentEl: HTMLElement;
  supabase: SupabaseClient;
  session: { token: string; tenantId: string; marketplaceKind: string };
  supabaseUrl: string;
}

const HEADER_HTML = `
  <header class="apphead">
    <a class="brand" href="https://www.go-ecommerce.de" target="_blank" rel="noopener" title="go eCommerce">
      <img src="/logo-black.png" alt="go eCommerce" />
    </a>
    <img class="gambio-logo" src="/gambio-logo.png?v=2" alt="Gambio" />
    <span class="hdivider"></span>
    <div class="htitle">
      <div class="heyebrow">Gambio · Bestellungen</div>
      <h1>Bestellübersicht ${infoBadge('Gambio-Bestellungen werden hier als VARIO-Belege übernommen.')}</h1>
    </div>
    <div class="hactions">${helpButtonHtml('bestellungen')}${connectionPillHtml()}</div>
  </header>
`;

export async function renderOrdersPage(ctx: OrdersPageContext): Promise<void> {
  ctx.contentEl.hidden = false;

  // Vario gibt diesem Slot via useFullHeight (in main.ts gesendet) die volle Viewport-Höhe.
  // Damit das Flex-Layout der Bestellansicht sie füllt und List/Detail INTERN scrollen, muss die
  // Ancestor-Kette auf 100% liegen (html → body → #app → #content). `.go-orders-fullpage` macht
  // den Container zur 100%-Flex-Spalte (CSS im geteilten gambio-orders.css).
  document.documentElement.style.height = '100%';
  document.body.style.height = '100%';
  const appEl = document.getElementById('app');
  if (appEl) appEl.style.height = '100%';
  ctx.contentEl.style.height = '100%';
  ctx.contentEl.classList.add('go-orders-fullpage');

  await renderOrdersTab(
    ctx.contentEl,
    {
      supabase: ctx.supabase,
      session: { token: ctx.session.token, tenantId: ctx.session.tenantId },
      supabaseUrl: ctx.supabaseUrl,
    },
    { headerHtml: HEADER_HTML },
  );

  wireHelpButtons(ctx.contentEl);
}
